import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import milestoneService from '../../services/milestoneService';
import './MilestoneList.css';
import CommonModal from '../../services/CommonModal';
import { customDateFormatShort } from '../../config/utils';
import resourceAllocationService from '../../services/resourceAllocationService';
import { FaCheck, FaChevronDown, FaChevronUp, FaEdit, FaFileExcel, FaInfo, FaInfoCircle, FaTimes, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { FiSave, FiX, FiAlertTriangle } from 'react-icons/fi';
import { set } from 'lodash';
import userService from '../../services/userService';

const statusOptions = [
  { value: 'All', label: 'All status' },
  { value: 'Not Started', label: 'Not Started' },
  { value: 'In Progress', label: 'In Progress' },
  { value: 'On Hold', label: 'On Hold' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Cancelled', label: 'Cancelled' },
];


const realStatuses = statusOptions
  .map((s) => s.value)
  .filter((v) => v !== 'All');

const MilestoneList = () => {
  const [milestones, setMilestones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedMilestone, setSelectedMilestone] = useState({});
  const [selectedMilestoneId, setSelectedMilestoneId] = useState(null);
  const [showResourceModal, setShowResourceModal] = useState(false);
  const [showAddResourceModal, setShowAddResourceModal] = useState(false);
  const [resourceAllocations, setResourceAllocations] = useState([]);
  const [resourceLoading, setResourceLoading] = useState(false);
  const [resourceError, setResourceError] = useState(null);
  const [resourceSubmitting, setResourceSubmitting] = useState(false);
  const [selectedAllocation, setSelectedAllocation] = useState(null);
  const [allocationDays, setAllocationDays] = useState({});
  const [resourceContext, setResourceContext] = useState({
    projectId: null,
    milestoneId: null,
  });
  const [showStatus, setShowStatus] = useState(false);
  const [filters, setFilters] = useState({ status: ['In Progress'] });
  const statusDropdownRef = useRef(null);
  const [showDateModal, setShowDateModal] = useState(false);
  const [dateForm, setDateForm] = useState({
    from_date: "",
    to_date: "",
    total_days: ""
  });

  const [errors, setErrors] = useState({});
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({
    project_id: "",
    milestone_id: "",
    user_id: "",
    first_name: "",
    last_name: "",
    email: "",
    role: "",
    allocation_percentage: 100,
    start_date: "",
  });

  console.log("users===", users)
  console.log("selectedAllocation===", selectedAllocation)
  console.log("resourceAllocations===", resourceAllocations)

  const [resForm, setResForm] = useState({});

  const handleResInputChange = (id, value) => {
    setResForm((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const [showAddForm, setShowAddForm] = useState(false);
  const [leaveDates, setLeaveDates] = useState([]);
  const [editIndex, setEditIndex] = useState(null);

  // add resource modal start
const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "user_id") {
    const selectedUser = users.find(
      (user) => String(user.id) === String(value)
    );

    console.log("resourceAllocations222:", resourceAllocations);
    console.log("SELECTED ROLE:", selectedUser?.role);

    setFormData((prev) => ({
      ...prev,
      user_id: value,
      first_name: selectedUser?.first_name || "",
      last_name: selectedUser?.last_name || "",
      email: selectedUser?.email || "",
      role: selectedUser?.role ||  "",
    }));
  } else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  if (errors?.[name]) {
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  }
};

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "user_id") {
  //     const selectedUser = users.find(
  //       (user) => String(user.id) === String(value)
  //     );

  //     setFormData((prev) => ({
  //       ...prev,
  //       user_id: value,
  //       first_name: selectedUser?.first_name || "",
  //       last_name: selectedUser?.last_name || "",
  //       email: selectedUser?.email || "",
  //       role: selectedUser?.role || "",
  //     }));
  //   } else {
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   }

  //   if (errors?.[name]) {
  //     setErrors((prev) => ({
  //       ...prev,
  //       [name]: "",
  //     }));
  //   }
  // };
const handleCreateResource = async (e) => {
  e?.preventDefault();

  console.log("selectedAllocation===:", selectedAllocation);
  console.log("resourceContext===:", resourceContext);
  console.log("formData===:", formData);

  const payload = {
    project_id: resourceContext?.projectId,
    // milestone_id: resourceContext?.milestoneId,
    allocation_percentage: resourceAllocations?.allocation_percentage || 100,
    user_id: formData.user_id,
    start_date: resourceAllocations[0]?.start_date ? formatDate(resourceAllocations.start_date) : "",
    // start_date: formData?.start_date,
    role: formData.role,
    first_name: formData.first_name,
    last_name: formData.last_name,
    email: formData.email,
  };

  console.log("FINAL RESOURCE PAYLOAD:", payload);

  try {
    const data = await resourceAllocationService.create(payload);

    console.log("RESOURCE CREATED:", data);

    toast.success("Resource added successfully");
    setShowAddResourceModal(false);
    fetchMilestones();
    handleResourceSubmit();
  } catch (error) {
    console.error("Error creating resource allocation:", error);

    setErrors({
      submit: "Failed to create resource",
    });
  }
};


  const addResourceInModal = async () => {
    try {
      const response = await userService.getAllUsers();
      console.log("FULL USERS RESPONSE:", response);
      setUsers(response.users);     
    } catch (error) {
      console.error("Error fetching users:", error);
      setError("Failed to fetch users");
    }
  };
  // add resource modal end

  const handleEdit = (index, item) => {
    setEditIndex(index);

    setDateForm({
      from_date: item.from_date,
      to_date: item.to_date,
    });
  };

  const handleDateDelete = (index) => {
    setLeaveDates(leaveDates.filter((_, i) => i !== index));
  };

  const handleOpenModal = (allocation) => {
    setSelectedAllocation(allocation);
    console.log("alloo", allocation)
    setDateForm({
      from_date: allocation.from_date,
      to_date: allocation.to_date,
    });
    setShowDateModal(true);
  };

  const handleSubmit = () => {
    console.log(selectedAllocation, dateForm);

    // Call your API here

    setShowDateModal(false);
  };

  const calculateActualDays = (fromDate, toDate) => {
    if (!fromDate || !toDate) {
      return 0;
    }

    const from = new Date(fromDate);
    const to = new Date(toDate);

    const diffTime = to.getTime() - from.getTime();

    if (diffTime < 0) {
      return 0;
    }

    return Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
  };

  const confirmDelete = () => {
    console.log("uuuu")
    handleDelete(selectedMilestone.id);
    setShowDeleteModal(false);
  };
  const navigate = useNavigate();

  useEffect(() => {
    fetchMilestones();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        statusDropdownRef.current &&
        !statusDropdownRef.current.contains(event.target)
      ) {
        setShowStatus(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };

    addResourceInModal();
  }, []);

  const fetchMilestones = async () => {
    try {
      setLoading(true);
      const data = await milestoneService.getAllMilestones();
      setMilestones(data.data || []);
      setError(null);
      console.log("milestones===", data.data)
    } catch (err) {
      setError('Failed to fetch milestones');
      console.error('Error fetching milestones:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (value) => {
    setFilters((prev) => {
      if (value === 'All') {
        const allSelected = realStatuses.every((s) =>
          prev.status.includes(s)
        );
        return { ...prev, status: allSelected ? [] : [...realStatuses] };
      }

      const isSelected = prev.status.includes(value);
      const nextStatus = isSelected
        ? prev.status.filter((s) => s !== value)
        : [...prev.status, value];

      return { ...prev, status: nextStatus };
    });
  };

  const filteredMilestones = useMemo(() => {
    if (!filters.status.length) return milestones;
    return milestones.filter((m) => filters.status.includes(m.status));
  }, [milestones, filters.status]);

  const handleDelete = async (id) => {
    try {
      await milestoneService.deleteMilestone(id);
      fetchMilestones();
    } catch (err) {
      alert('Failed to delete milestone');
      console.error('Error deleting milestone:', err);
    }
  };

  console.log("selectedMilestone", selectedMilestoneId)

  const handleResourceClick = async (projectId, milestone) => {
    if (!projectId) return;
    setShowResourceModal(true);
    setResourceLoading(true);
    setResourceError(null);
    const milestoneId = milestone?.id ?? milestone?.milestone_id;
    setResourceContext({ projectId, milestoneId });
    setSelectedMilestoneId(milestone)

    console.log("fffff", milestoneId)

    // Set required project/milestone information
    setFormData((prev) => ({
      ...prev,
      project_id: projectId,
      milestone_id: milestoneId || "",
    }));

    try {
      const data = await resourceAllocationService.getAll({
        project_id: projectId,
        milestone_id: milestoneId,
        page: 1,
        limit: 10,
      });

      const allocations = (data.data || []).filter(({ is_active }) => is_active === true).map((allocation) => ({
        ...allocation,
        projectInput: allocation.project
          ? `${allocation.project.name} (${allocation.project.code})`
          : '',
      }));
      setResourceAllocations(allocations);

      const usersList = (data?.data || [])
 

      console.log("dataaaaa===", allocations)
    } catch (err) {
      toast.error('Failed to fetch resource allocations');
      console.error('Error fetching resource allocations:', err);
      setResourceAllocations([]);
    } finally {
      setResourceLoading(false);
    }
  };

  useEffect(() => {
    if (resourceAllocations?.length) {
      const initialForm = {};

      resourceAllocations.forEach((allocation) => {
        initialForm[allocation.id] = allocation.per_day_count ?? "";
      });

      setResForm(initialForm);
    }
  }, [resourceAllocations]);

  const handleResourceSubmit = async () => {
    const { projectId, milestoneId } = resourceContext;

    console.log("formmm", resForm)

    const payload = {
      project_id: projectId,
      milestone_id: selectedMilestoneId.id,

      resources: resourceAllocations.map((allocation) => ({
        user_id: allocation?.user_id || allocation.user?.id,

        per_day_count:
          resForm[allocation.id] === "" ||
            resForm[allocation.id] === null ||
            resForm[allocation.id] === undefined
            ? 0
            : Number(resForm[allocation.id]),

        available_days:
          allocation.available_days === "" ||
            allocation.available_days === null ||
            allocation.available_days === undefined
            ? 0
            : Number(allocation.available_days),
      })),
    };

    setResourceSubmitting(true);
    setResourceError(null);
    try {
      await milestoneService.submitMilestoneResourceAvailability(
        payload
      );
      setShowResourceModal(false);
      setResourceContext({ projectId: null, milestoneId: null });
    } catch (err) {
      toast.error('Failed to submit resource availability');
      console.error('Error submitting resource availability:', err);
    } finally {
      setResourceSubmitting(false);
    }
  };

  const handleProjectInputChange = (allocationId, value) => {
    setResourceAllocations((prev) =>
      prev.map((allocation) =>
        allocation.id === allocationId
          ? { ...allocation, available_days: value }
          : allocation
      )
    );
  };

  const getStatusBadgeClass = (status) => {
    const statusMap = {
      'Not Started': 'badge-secondary',
      'In Progress': 'badge-primary',
      Completed: 'badge-success',
      'On Hold': 'badge-warning',
      Cancelled: 'badge-danger',
    };
    return statusMap[status] || 'badge-secondary';
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return customDateFormatShort(dateString);
  };

  if (loading) {
    return <div className="loading">Loading milestones...</div>;
  }

  const handleMilestoneClick = (id, isEdit) => {
    navigate(`/app/milestones/${id}/edit`);
    console.log("iddd", id, isEdit)
  };;

  const handleDownloadMilestoneList = () => {
    if (!filteredMilestones || filteredMilestones.length === 0) {
      toast.error('No milestones to download');
      return;
    }

    const headers = [
      'Name', 'Project', 'Squad', 'Allocated Resources',
      'Status', 'Due Date', 'Completion Date'
    ];

    const escapeCsv = (value) => {
      if (value === null || value === undefined) return '';
      const str = String(value);
      if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };

    const rows = filteredMilestones.map((milestone) => [
      milestone.name,
      milestone.project ? `${milestone.project.name} (${milestone.project.code})` : 'N/A',
      milestone.squad ? milestone.squad.name : '-',
      milestone.allocated_resources ?? 0,
      milestone.status,
      formatDate(milestone.due_date),
      formatDate(milestone.completion_date)
    ]);

    const csvContent = [headers, ...rows]
      .map((row) => row.map(escapeCsv).join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `milestone-list-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    toast.success('Milestone list downloaded');
  };

  const handleDownloadResourceAvailability = () => {
    if (!resourceAllocations || resourceAllocations.length === 0) {
      toast.error('No milestones to download');
      return;
    }

    const headers = [
      'Sprint ', 'Start date', 'End date', 'Name', 'Leave days',
      'Role', 'Capacity Hours / Day'
    ];

    const escapeCsv = (value) => {
      if (value === null || value === undefined) return '';
      const str = String(value);
      if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };

    const rows = resourceAllocations.map((milestone) => [
      selectedMilestoneId.name,
      formatDate(milestone.start_date),
      formatDate(milestone.end_date),
      milestone.user.first_name + " " + milestone.user.last_name,
      milestone.leave_days,
      milestone.role,
      milestone.per_day_count,
    ]);

    const csvContent = [headers, ...rows]
      .map((row) => row.map(escapeCsv).join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${selectedMilestoneId.name}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    toast.success('File exported successfully');
  };

  const handleDateSubmit = async () => {
    const { from_date, to_date } = dateForm;

    if (!from_date || !to_date) {
      toast.error("Please select both dates.");
      return;
    }

    const start = new Date(from_date);
    const end = new Date(to_date);

    if (end < start) {
      toast.error("End Date should be greater than or equal to Start Date.");
      return;
    }

    // Inclusive days (e.g. Aug 1 to Aug 1 = 1 day)
    const diffDays =
      Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;

    setAllocationDays((prev) => ({
      ...prev,
      [selectedAllocation.id]: diffDays,
    }));


    try {

      const payload = {
        "project_id": selectedAllocation.project_id,
        "milestone_id": selectedMilestoneId.id,
        "user_id": selectedAllocation.user_id,
        "from_date": dateForm.from_date,
        "to_date": dateForm.to_date,
        "no_of_days": diffDays

      }
      console.log("payload", payload)

      const data = await resourceAllocationService.submitLeaveAvailability(payload);
      toast.success("Submitted successfully")

      console.log("datttt-mmmm", selectedMilestoneId)

      handleResourceClick(selectedAllocation.project_id, selectedMilestoneId)
      setShowDateModal(false);
    } catch (err) {
      toast.error('Failed to fetch resource allocations');
      console.error('Error fetching resource allocations:', err);
    } finally {
      setResourceLoading(false);
    }

  };






  return (
    <div className="milestone-list-container">
      <div className="milestone-list-header">
        <h2>Milestones</h2>
        <div className="flex gap-3">
          <Link to="/app/milestones/new" className="btn btn-primary">
            <i className="fas fa-plus"></i> New Milestone
          </Link>
          <button
            onClick={handleDownloadMilestoneList}
            className="px-4 py-3 bg-white border border-green-600 text-green-600 rounded-lg flex items-center gap-2"
            title="Download milestone list"
          >
            <FaFileExcel />
          </button>
        </div>
      </div>

      <div className="relative" ref={statusDropdownRef} style={{ maxWidth: 260, marginBottom: '1rem' }}>
        <button
          type="button"
          onClick={() => setShowStatus((prev) => !prev)}
          className="flex w-full items-center justify-between rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-200"
        >
          <span className="truncate">
            {filters.status.length ? filters.status.join(', ') : 'All Status'}
          </span>

          {showStatus ? <FaChevronUp /> : <FaChevronDown />}
        </button>

        {showStatus && (
          <div className="absolute left-0 right-0 z-50 mt-2 max-h-64 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-lg">
            {statusOptions.map((status) => (
              <label
                key={status.value}
                className="flex cursor-pointer items-center gap-3 px-4 py-2 hover:bg-gray-100"
              >
                <input
                  type="checkbox"
                  checked={
                    status.value === 'All'
                      ? realStatuses.every((s) => filters.status.includes(s))
                      : filters.status.includes(status.value)
                  }
                  onChange={() => handleStatusChange(status.value)}
                />
                {status.label}
              </label>
            ))}
          </div>
        )}
      </div>

      {error && <div className="alert alert-danger">{error}</div>}
      <CommonModal
        isOpen={showDeleteModal}
        title="Delete Milestone"
        message="Are you sure you want to delete this milestone?"
        onClose={() => {
          setShowDeleteModal(false);
          setSelectedMilestone(null);
        }}
        onConfirm={confirmDelete}
        type="error"
        confirmText="Delete"
        cancelText="Cancel"
      />

      {/* Resource Allocation Popup */}
      {showResourceModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={() => setShowResourceModal(false)}
        >
          <div
            className="w-[50%] overflow-hidden rounded-xl bg-white shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="flex items-center justify-between px-6 py-4"
              style={{ background: '#1F2937' }}
            >
              <h3 className="text-xl font-semibold text-white">
                Resource Availability <sub>{selectedMilestoneId?.name}({customDateFormatShort(selectedMilestoneId?.due_date)} - {customDateFormatShort(selectedMilestoneId?.completion_date)})</sub>
              </h3>

              <span className='flex'>
                <button
                  onClick={handleDownloadResourceAvailability}
                  className="mr-5 px-4 py-3 bg-white border border-green-600 text-green-600 rounded-lg flex items-center gap-2"
                  title="Download milestone list"
                >
                  <FaFileExcel />
                </button>

                <button
                  onClick={() => setShowResourceModal(false)}
                  className="text-3xl leading-none text-white transition hover:text-gray-200"
                >
                  &times;
                </button>
              </span>

            </div>

            <div className="max-h-[60vh]  overflow-y-auto p-4">
              {resourceLoading ? (
                <div className="py-10 text-center text-gray-600">
                  Loading resource allocations...
                </div>
              ) : resourceError ? (
                <div className="rounded-md border border-red-300 bg-red-100 p-3 text-red-700">
                  {resourceError}
                </div>
              ) : resourceAllocations.length === 0 ? (
                <div className="py-10 text-center text-gray-500">
                  No resource allocations found.
                </div>
              ) : (
                <div className="overflow-x-auto">
                  {/* {JSON.stringify(selectedMilestoneId, null, 2)} */}
                  <table className="min-w-full border border-gray-200">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="px-4 py-3 text-left text-sm font-semibold">
                          User
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-semibold"></th>
                        <th className="px-4 py-3 text-left text-sm font-semibold">
                          Role
                        </th>

                        <th className="px-4 py-3 text-left text-sm font-semibold">
                          Capacity Hours / Day
                        </th>
                        {/* <th className="px-4 py-3 text-left text-sm font-semibold">
Role
                        </th>
                        <th className="px-4 py-3 text-left text-sm font-semibold">
                          Allocation
                        </th> */}
                      </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-200">
                      {Array.from(
                        new Map(
                          resourceAllocations.map((allocation) => [
                            allocation.user?.id,
                            allocation,
                          ])
                        ).values()
                      ).map((allocation) => (
                        <tr
                          key={allocation.id}
                          className="transition hover:bg-gray-50"
                        >
                          <td className="px-4 py-3">
                            <div className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-full bg-blue-500 font-semibold text-white">
                              {allocation.user?.avatar_url ? (
                                <img
                                  src={allocation.user.avatar_url}
                                  alt={`${allocation.user.first_name} ${allocation.user.last_name}`}
                                  className="h-full w-full object-cover"
                                />
                              ) : (
                                <>
                                  {allocation.user?.first_name?.[0]}
                                  {allocation.user?.last_name?.[0]}
                                </>
                              )}
                            </div>
                          </td>

                          <td className="px-4 py-3">
                            <div>
                              <div className="font-medium text-gray-900 flex mt-5">
                                {allocation.user?.first_name} {allocation.user?.last_name}

                                <sub
                                  className="ml-1 cursor-pointer text-blue-600 hover:text-blue-800 text-xs"
                                  onClick={() => handleOpenModal(allocation)}
                                >
                                  {allocation.leave_days || 0} days
                                </sub>
                              </div>

                              {/* <div className="text-sm text-gray-500">
                                {allocation.user?.email}
                              </div> */}
                            </div>
                          </td>

                          <td className="px-4 py-3">
                            <span>{allocation?.role}</span>
                          </td>
                          <td className="px-4 py-3 w-[8rem]">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="9"
                              value={resForm[allocation.id] ?? allocation.per_day_count ?? ""}
                              onChange={(e) =>
                                handleResInputChange(allocation.id, e.target.value)
                              }
                            />
                          </td>
                          {showDateModal && (
                            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/10 backdrop-blur-sm">
                              <div className="w-[50%] rounded-lg bg-white p-6 shadow-xl">
                                <h2 className="mb-5 text-lg font-semibold">Leave Planner</h2>

                                <div className="mb-4 flex justify-end">
                                  {!showAddForm && (
                                    <button
                                      onClick={() => {
                                        setShowAddForm(true);
                                        setEditIndex(null);
                                        setDateForm({
                                          from_date: "",
                                          to_date: "",
                                        });
                                      }}
                                      className="rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
                                    >
                                      Add More
                                    </button>
                                  )}
                                </div>

                                <div className="overflow-x-auto rounded-lg border">
                                  <table className="w-full border-collapse">
                                    <thead className="bg-gray-100">
                                      <tr>
                                        <th className="border p-3 text-left">From</th>
                                        <th className="border p-3 text-left">To</th>
                                        <th className="border p-3 text-left">Applied Day(s)</th>
                                        <th className="border p-3 text-center">Actions</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {/* Existing Rows */}
                                      {selectedAllocation?.resource_leaves?.map((item, index) => (
                                        <tr key={index}>
                                          {editIndex === index ? (
                                            <>
                                              <td className="border p-3">
                                                <input
                                                  type="date"
                                                  className="form-control w-full rounded border p-1"
                                                  value={dateForm.from_date}
                                                  onChange={(e) =>
                                                    setDateForm({
                                                      ...dateForm,
                                                      from_date: e.target.value,
                                                    })
                                                  }
                                                />
                                              </td>
                                              <td className="border p-3">
                                                <input
                                                  type="date"
                                                  className="form-control w-full rounded border p-1"
                                                  value={dateForm.to_date}
                                                  onChange={(e) =>
                                                    setDateForm({
                                                      ...dateForm,
                                                      to_date: e.target.value,
                                                    })
                                                  }
                                                />
                                              </td>
                                              <td className="border p-3">{item.no_of_days}</td>
                                              <td className="border p-3">
                                                <div className="flex justify-center gap-2">
                                                  <button
                                                    onClick={handleDateSubmit}
                                                    className="rounded-md bg-blue-600 p-2 text-white hover:bg-blue-700"
                                                    title="Save"
                                                  >
                                                    <FaCheck size={16} />
                                                  </button>
                                                  <button
                                                    onClick={() => {
                                                      setEditIndex(null);
                                                      setDateForm({
                                                        from_date: "",
                                                        to_date: "",
                                                      });
                                                    }}
                                                    className="rounded-md border border-gray-300 bg-gray-100 p-2 text-gray-700 hover:bg-gray-200"
                                                    title="Cancel"
                                                  >
                                                    <FaTimes size={16} />
                                                  </button>
                                                </div>
                                              </td>
                                            </>
                                          ) : (
                                            <>
                                              <td className="border p-3">
                                                {customDateFormatShort(item.from_date)}
                                              </td>
                                              <td className="border p-3">
                                                {customDateFormatShort(item.to_date)}
                                              </td>
                                              <td className="border p-3">{item.no_of_days}</td>
                                              <td className="border p-3">
                                                <div className="flex items-center justify-center gap-3">
                                                  <button
                                                    onClick={() => handleEdit(index, item)}
                                                    className="rounded-md bg-blue-600 p-2 text-white hover:bg-blue-700"
                                                    title="Edit"
                                                  >
                                                    <FaEdit size={16} />
                                                  </button>
                                                  <button
                                                    onClick={() => handleDateDelete(index)}
                                                    className="rounded-md bg-red-600 p-2 text-white hover:bg-red-700"
                                                    title="Delete"
                                                  >
                                                    <FaTrash size={16} />
                                                  </button>
                                                </div>
                                              </td>
                                            </>
                                          )}
                                        </tr>
                                      ))}

                                      {/* New Row appended below existing list when Add Leave is clicked */}
                                      {(showAddForm || selectedAllocation?.resource_leaves?.length === 0) && (
                                        <tr className="bg-blue-50/50">
                                          <td className="border p-3">
                                            <input
                                              type="date"
                                              className="form-control w-full rounded border p-1"
                                              value={dateForm.from_date}
                                              onChange={(e) =>
                                                setDateForm({
                                                  ...dateForm,
                                                  from_date: e.target.value,
                                                })
                                              }
                                            />
                                          </td>
                                          <td className="border p-3">
                                            <input
                                              type="date"
                                              className="form-control w-full rounded border p-1"
                                              value={dateForm.to_date}
                                              onChange={(e) =>
                                                setDateForm({
                                                  ...dateForm,
                                                  to_date: e.target.value,
                                                })
                                              }
                                            />
                                          </td>
                                          <td className="border p-3 text-sm">
                                            {dateForm.from_date && dateForm.to_date ? (
                                              <span className="font-semibold text-gray-700">
                                                {calculateActualDays(
                                                  dateForm.from_date,
                                                  dateForm.to_date
                                                )}{" "}

                                              </span>
                                            ) : (
                                              <span className="italic text-gray-400">
                                                Select both dates
                                              </span>
                                            )}
                                          </td>
                                          <td className="border p-3">
                                            <div className="flex justify-center gap-2">
                                              <button
                                                onClick={handleDateSubmit}
                                                className="rounded-md bg-blue-600 p-2 text-white hover:bg-blue-700"
                                                title="Save"
                                              >
                                                <FaCheck size={16} />
                                              </button>
                                              {selectedAllocation?.resource_leaves?.length > 0 && (
                                                <button
                                                  onClick={() => {
                                                    setShowAddForm(false);
                                                    setDateForm({ from_date: "", to_date: "" });
                                                  }}
                                                  className="rounded-md border border-gray-300 bg-gray-100 p-2 text-gray-700 hover:bg-gray-200"
                                                  title="Cancel"
                                                >
                                                  <FaTimes size={16} />
                                                </button>
                                              )}
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>

                                <div className="mt-6 flex justify-end gap-3">


                                  <div>
                                    <button
                                      onClick={() => {
                                        setShowDateModal(false);
                                        setShowAddForm(false);
                                        setEditIndex(null);
                                      }}
                                      className="rounded-md border px-4 py-2 hover:bg-gray-50"
                                    >
                                      Close
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* <td className="px-4 py-3">
                            <span className="rounded-full bg-blue-100 px-3 py-1 text-sm font-medium text-blue-700">
                              {allocation.role || 'N/A'}
                            </span>
                          </td>

                          <td className="px-4 py-3">
                            <span
                              className={`allocation-badge ${resourceAllocationService.getUtilizationBadgeColor(
                                allocation.allocation_percentage
                              )}`}
                            >
                              {allocation.allocation_percentage}%
                            </span>
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {!resourceLoading && !resourceError && resourceAllocations.length > 0 && (
              <div className="flex justify-between border-t border-gray-200 px-4 py-3 gap-4">



                <div className='flex gap-4'>
                  <div>
                    <p>Working Days: {selectedMilestoneId?.working_days || 0}</p>

                  </div>

                  <div>
                    Public Holydays: {selectedMilestoneId?.public_holidays || 0}
                  </div>

                  <div className='mt-1'>
                    <p title={selectedMilestoneId?.holiday_note || ''}>
                      <FaInfoCircle className="text-blue-500 cursor-pointer" />
                    </p>
                  </div>
                </div>

                <span className='gap-4 flex'>
                  <button className='btn btn-sm btn-outline-primary custom-pbtn !text-white'
                    type="button"
                    onClick={() => {
                      // addResourceInModal();
                      // setShowAddResourceModal(true);
                       navigate("/app/resources");
                    }}
                  >
                    Add Resource
                  </button>                 

                  <button
                    type="button"
                    onClick={handleResourceSubmit}
                    disabled={resourceSubmitting}
                    className="btn btn-primary rounded-md px-4 py-2 text-sm font-semibold"
                  >
                    {resourceSubmitting ? 'Submitting...' : 'Submit'}
                  </button>
                </span>
              </div>
            )}
          </div>
        </div>
      )}


      {/* Resource Allocation Popup */}
      {showAddResourceModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
        // onClick={() => setShowAddResourceModal(false)}
        >
          <div
            className="w-[50%] overflow-hidden rounded-xl bg-white shadow-2xl"
          // onClick={(e) => e.stopPropagation()}
          >
            <div
              className="flex items-center justify-between px-6 py-4"
              style={{ background: '#1F2937' }}
            >
              <h3 className="text-xl font-semibold text-white"> Add Resource   </h3>

              <span className='flex'>
                <button
                  onClick={() => setShowAddResourceModal(false)}
                  className="text-3xl leading-none text-white transition hover:text-gray-200"
                >
                  &times;
                </button>
              </span>

            </div>

            {/* Resource Allocation Form popup body start */}
            <div className="max-h-[60vh]  overflow-y-auto p-4">
              <div className=" ">
                <form onSubmit={handleSubmit}>
                  <div className=" ">
                    <div className="form-group">
                      <label>User *</label>

                      <select
                        name="user_id"
                        value={formData.user_id || ""}
                        onChange={handleChange}
                        className={errors?.user_id ? "error" : ""}
                        required
                      >
                        <option value="">Select User</option>

                        {Array.isArray(users) && users.map((user) => (
                          <option key={user.id} value={user.id}>
                            {user.first_name} {user.last_name}
                            {user.email ? ` (${user.email})` : ""}
                          </option>
                        ))}
                      </select>

                      {errors?.user_id && (
                        <span className="error-message">
                          {errors.user_id}
                        </span>
                      )}
                    </div>   
                    
                    <div className="form-group">
                      <label>Role</label>
                      <input
                        type="text"
                        name="role"
                        value={formData.role || ""}
                        onChange={handleChange}
                        placeholder="e.g., Developer, Designer, QA"
                      />
                    </div>                   
                  </div> 

                </form>
              </div>

              {/* <ResourceCreate createResource={createMilestone} /> */}

            </div>
            {/* Resource Allocation Form popup body end */}

            <div className="flex justify-end border-t border-gray-200 px-4 py-3 gap-4">

              <span className='gap-4 flex '>
                <button
                  type="button"
                  onClick={handleCreateResource}
                  disabled={resourceSubmitting}
                  className="btn btn-primary rounded-md px-4 py-2 text-sm font-semibold"
                >
                  {resourceSubmitting ? 'Adding...' : 'Add'}
                </button>
              </span>
            </div>
          </div>
        </div>
      )}

      <div className="milestone-stats">
        <div className="stat-card">
          <h3>{milestones.length}</h3>
          <p>Total Milestones</p>
        </div>
        <div className="stat-card">
          <h3>{milestones.filter((m) => m.status === 'Completed').length}</h3>
          <p>Completed</p>
        </div>
        <div className="stat-card">
          <h3>
            {milestones.filter((m) => m.status === 'In Progress').length}
          </h3>
          <p>In Progress</p>
        </div>
        <div className="stat-card">
          <h3>
            {milestones.filter((m) => m.status === 'Not Started').length}
          </h3>
          <p>Not Started</p>
        </div>
        <div className="stat-card">
          <h3>
            {milestones.filter((m) => m.status === 'On Hold').length}
          </h3>
          <p>On Hold</p>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table milestone-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Project</th>
              <th style={{ textAlign: 'center' }}>Squad</th>
              <th style={{ textAlign: 'center' }}>Resource</th>
              <th>Status</th>
              <th>Due Date</th>
              <th>Completion Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredMilestones.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center">
                  No milestones found. <Link to="/app/milestones/new">Create one</Link>
                </td>
              </tr>
            ) : (
              filteredMilestones.map((milestone) => (
                <tr key={milestone.id}>
                  <td>
                    <span
                      className="milestone-name cursor-pointer"
                      onClick={() => handleMilestoneClick(milestone.id, true)}
                    >
                      {milestone.name}
                    </span>
                  </td>
                  <td>
                    {milestone.project ? (
                      <Link to={`/app/projects/${milestone.project.id}/edit`}>
                        {milestone.project.name} ({milestone.project.code})
                      </Link>
                    ) : (
                      'N/A'
                    )}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {milestone.squad ? (
                      <span className="  px-3 py-1 text-sm font-medium text-blue-700">
                        {milestone.squad.name}
                      </span>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td className="text-center milestone-name cursor-pointer" style={{ color: 'red' }}>
                    <span onClick={() => handleResourceClick(milestone.project?.id, milestone)}>
                      {milestone.allocated_resources}
                    </span>
                  </td>
                  <td>
                    <span className={`badge ${getStatusBadgeClass(milestone.status)}`}>
                      {milestone.status}
                    </span>
                  </td>
                  <td>{customDateFormatShort(milestone.due_date)}</td>
                  <td>{customDateFormatShort(milestone.completion_date)}</td>
                  <td>
                    <div className="flex gap-3">
                      <Link
                        to={`/app/milestones/${milestone.id}/edit`}
                        className="btn btn-sm btn-outline-primary custom-pbtn"
                        title="Edit"
                      >
                        <i className="fas fa-edit custom-fas-icon"></i>
                      </Link>
                      <button
                        onClick={() => {
                          setSelectedMilestone(milestone);
                          setShowDeleteModal(true);
                        }}
                        className="btn btn-sm btn-outline-danger custom-dbtn"
                        title="Delete"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MilestoneList;